import { gsap } from "gsap";
import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../GameFont";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";

export class FullBuildingTooltip extends Container {
    private static readonly ANIMATION_TIME = 0.25;

    private readonly animationTimeLine: gsap.core.Timeline;
    private readonly tooltipBg: Sprite;
    private readonly tooltipText: Text;
    private readonly closeButton: Sprite;
    private readonly pointer: Sprite;

    public constructor(commonResources: CommonResourcesPackage) {
        super();
        this.animationTimeLine = new gsap.core.Timeline();
        this.pointer = new Sprite(commonResources.assets_common_ui_tooltips_tooltip_pointer_png);
        this.pointer.anchor.set(0.5);
        this.addChild(this.pointer);
        this.tooltipBg = new Sprite(commonResources.assets_common_ui_tooltips_tooltip_bg_png);
        this.tooltipBg.anchor.set(0.5);
        this.addChild(this.tooltipBg);
        this.tooltipText = new Text('', new TooltipTextStyle());
        this.tooltipText.y = -16;
        this.tooltipText.anchor.set(0.5);
        this.addChild(this.tooltipText);
        this.closeButton = new Sprite(commonResources.assets_common_x_png);
        this.closeButton.eventMode = "dynamic";
        this.closeButton.on("pointerdown", this.hideHint, this);
        this.closeButton.anchor.set(0.5);
        this.closeButton.scale.set(0.4);
        this.closeButton.position.set(228, -58);
        this.addChild(this.closeButton);
        this.visible = false;
    }

    public async showHint(tooltipText: string, pointePosition: number): Promise<void> {
        this.visible = true;
        switch (pointePosition) {
            case 1:
                this.pointer.position.set(-223, 63);
                break;
            case 2:
                this.pointer.position.set(-100, 63);
                break;
            case 3:
                this.pointer.position.set(56, 63);
                break;
            case 4:
                this.pointer.position.set(223, 63);
                break;
            case 5:
                this.pointer.position.set(200, 63);
                break;
            case 6:
                this.pointer.position.set(105, 63);
                break;
        }
        this.tooltipText.text = tooltipText;
        this.animationTimeLine.to(this, { alpha: 1, duration: FullBuildingTooltip.ANIMATION_TIME, ease: "power1.inOut" });
        await this.animationTimeLine;
        this.animationTimeLine.clear();
    }

    public async hideHint(): Promise<void> {
        this.animationTimeLine.to(this, { alpha: 0, duration: FullBuildingTooltip.ANIMATION_TIME, ease: "power1.inOut" });
        await this.animationTimeLine;
        this.animationTimeLine.clear();
        this.visible = false;
    }

    public changeTooltipTextColor(color: string): void {
        this.tooltipText.style.fill = color;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.animationTimeLine.kill();
        this.closeButton.off("pointerdown");
        super.destroy(options);
    }
}

class TooltipTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36
        }));
    }
}